import React from 'react';
import { SVGProps } from 'react';

export const SvgBigSuccessIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={44}
        height={44}
        fill="none"
        style={{ display: 'block', margin: '0 auto' }}
        viewBox={'0 0 44 44'}
        {...props}
    >
        <g fillRule="evenodd" clipRule="evenodd">
            <path
                fill="#26CD58"
                d="M.194 16.925C.67 10.53.908 7.332 4.118 4.123 7.327.913 10.524.676 16.919.2a68.708 68.708 0 0 1 5.078-.198c1.71 0 3.42.074 5.078.198 6.395.476 9.592.714 12.802 3.923 3.209 3.21 3.447 6.407 3.923 12.802a68.69 68.69 0 0 1 .198 5.078c0 1.71-.075 3.42-.198 5.077-.476 6.395-.714 9.593-3.923 12.802-3.21 3.21-6.407 3.447-12.802 3.923a68.745 68.745 0 0 1-5.078.199c-1.71 0-3.42-.075-5.078-.199-6.395-.476-9.592-.714-12.801-3.923C.908 36.672.67 33.475.194 27.08a68.703 68.703 0 0 1-.198-5.077c0-1.71.075-3.42.198-5.078Z"
            />
            <path
                fill="#fff"
                d="M32.285 17.617a2.445 2.445 0 0 0-3.457-3.457l-9.272 9.272-3.16-3.16a2.445 2.445 0 0 0-3.457 3.456l4.889 4.89a2.445 2.445 0 0 0 3.457 0l11-11Z"
            />
        </g>
    </svg>
);
